import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App.jsx";
import "mouse-follower/dist/mouse-follower.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
